import mixpanel from 'mixpanel-browser'

export const trackPageView = (pageName, pageCategory) => {
  if (!pageName || !pageCategory) {
    return
  }

  mixpanel.track('Page View', {
    page_title: pageName,
    page_category: pageCategory, //marketing, bike, page, locations, referrals, etc. Trigger on componnentDidMount if you need dynamic info.
  })
}

export const trackPageViewUserPage = (userID) => {
  if (!userID) {
    return
  }
  mixpanel.track('Page View - User', {
    user_pretty_id: userID,
  })
}
